import React, { useEffect, useRef } from "react";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

const AdsterraAd = () => {
  const adRef = useRef(null);

  useEffect(() => {
    if (adRef.current && !adRef.current.hasChildNodes()) {
      // Insert the atOptions config script
      const configScript = document.createElement("script");
      configScript.type = "text/javascript";
      configScript.innerHTML = `
        atOptions = {
          'key' : 'e04399858f60b1962f62ab07d445fe6d',
          'format' : 'iframe',
          'height' : 250,
          'width' : 300,
          'params' : {}
        };
      `;
      adRef.current.appendChild(configScript);

      // Insert the ad script
      const adScript = document.createElement("script");
      adScript.type = "text/javascript";
      adScript.src = "//www.highperformanceformat.com/e04399858f60b1962f62ab07d445fe6d/invoke.js";
      adRef.current.appendChild(adScript);
    }
  }, []);

  return (
    <>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',   // <-- make children stack vertically
          justifyContent: 'center',
          alignItems: 'center',
          gap: 1,                    // spacing between typographies
          minHeight: 300,
          textAlign: 'center'
        }}
      >

        <Typography variant="caption" sx={{ padding: '0rem', fontSize: '1rem' }}>
          Frau Busfahrerin,
        </Typography>
        <Typography variant="caption" sx={{ padding: '0rem', fontSize: '1rem' }}>
          Herr Busfahrer,
        </Typography>
        <Typography variant="caption" sx={{ padding: '0rem', fontSize: '2rem', fontWeight: 'bold' }}>
          Danke für Ihren Einsatz!
        </Typography>
        <div ref={adRef} style={{ width: 300, height: 250 }} />
      </Card>
      
    </>
  );
};

export default AdsterraAd;